import { Home, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { m } from "framer-motion";
import { useGoBack } from "@/lib/useGoBack";

export default function NotFound() {
  const goBack = useGoBack("/");
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <m.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 200, damping: 15 }}
        className="text-8xl font-bold text-brand-500 mb-4"
      >
        404
      </m.div>
      <m.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15 }}
        className="text-2xl font-bold text-text-primary mb-2"
      >
        Page Not Found
      </m.h1>
      <m.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25 }}
        className="text-text-secondary mb-8 max-w-md"
      >
        The page you're looking for doesn't exist or has been moved.
      </m.p>
      <m.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35 }}
        className="flex items-center gap-3"
      >
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-brand-700 transition-colors"
        >
          <Home className="h-4 w-4" />
          Go to Dashboard
        </Link>
        <button
          onClick={goBack}
          className="inline-flex items-center gap-2 rounded-lg border border-border bg-surface-elevated px-4 py-2.5 text-sm font-medium text-text-primary hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Go Back
        </button>
      </m.div>
    </div>
  );
}
